// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__19tVv","label":"LabeledBox_label__2mY-Z"};